import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full pt-x2 md:pt-x3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroBannerHandler = _resolveComponent("HeroBannerHandler")!
  const _component_BlockList = _resolveComponent("BlockList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.content.hero)
      ? (_openBlock(), _createBlock(_component_HeroBannerHandler, {
          key: 0,
          content: _ctx.content.hero
        }, null, 8, ["content"]))
      : _createCommentVNode("", true),
    _createVNode(_component_BlockList, {
      blocks: _ctx.content.tiles
    }, null, 8, ["blocks"])
  ]))
}